var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArticle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.72772 8.62457H12.4737V2.46857H8.72772V8.62457ZM2.5263 13.5314H12.4731V12.3126H2.5263V13.5314ZM2.5263 11.0623H11.2143V9.84343H2.5263V11.0623ZM2.5263 8.62514H7.49998V7.37486H2.5263V8.62514ZM2.5263 6.156H7.49998V2.46857H2.5263V6.156ZM1.29915 14.7811H13.7014V1.21886H1.29915V14.7811ZM1.29915 0H13.7014C14.037 0 14.3248 0.12 14.5665 0.359429C14.8077 0.599429 14.9286 0.885714 14.9286 1.21886V14.7811C14.9286 15.1149 14.8077 15.4011 14.5665 15.6406C14.3248 15.8806 14.037 16 13.7014 16H1.29915C0.963001 16 0.67463 15.8806 0.433458 15.6406C0.19171 15.4011 0.0714111 15.1149 0.0714111 14.7811V1.21886C0.0714111 0.885714 0.19171 0.599429 0.433458 0.359429C0.67463 0.12 0.963001 0 1.29915 0Z",
  fill: "#999999"
}))));
export default SvgIconArticle;